export const LINK_PAGE_ITEM_TYPES = {
  LINK: "link",
  SOCIAL: "social",
  CONTACT: "contact",
  TEXT: "text",
  IMAGE: "image",
  VIDEO: "video",
  SOCIAL_ROW: "socialRow",
  BOOKING: "booking",
  TICKER: "ticker",
  REACTIONS: "reactions",
  EVENTS: "events",
  ARTICLES: "articles",
};

export const REACTION_EMOJIS = ["👏", "🔥", "❤️", "🎧", "😂", "🤯", "💯", "🙏"];

export const SECTION_LAYOUTS = [
  { value: "full", label: "Full", name: "Full width", columns: 1 },
  { value: "boxed", label: "Boxed", name: "Boxed", columns: 1 },
  { value: "two", label: "2 col", name: "2 columns", columns: 2 },
  { value: "three", label: "3 col", name: "3 columns", columns: 3 },
];

export const LINK_PAGE_THEME_PRESETS = [
  {
    key: "site-default",
    label: "Site default",
    theme: {
      presetKey: "site-default",
      backgroundStyle: "solid",
      backgroundColor: "#000000",
      backgroundAccentColor: "#000000",
      surfaceColor: "#1c1a1a",
      textColor: "#f8fafc",
      mutedTextColor: "rgba(248, 250, 252, 0.72)",
      buttonTextColor: "#ffffff",
      buttonBackgroundColor: "#2b6fe0",
      buttonOutlineColor: "rgba(255, 255, 255, 0.16)",
      buttonRadius: 20,
      buttonShadow: "none",
      buttonStyle: "solid",
      buttonSize: "comfortable",
      fontFamily: "Poppins",
      profileCardBackgroundColor: "#1c1a1a",
    },
  },
  {
    key: "bonjourno",
    label: "BonJourno",
    theme: {
      backgroundStyle: "gradient",
      backgroundColor: "#140d18",
      backgroundAccentColor: "#6f2938",
      surfaceColor: "rgba(255, 246, 238, 0.09)",
      textColor: "#fffaf5",
      mutedTextColor: "rgba(255, 250, 245, 0.72)",
      buttonTextColor: "#2b151c",
      buttonBackgroundColor: "#fff2e5",
      buttonOutlineColor: "rgba(255, 242, 229, 0.22)",
      buttonRadius: 20,
      buttonShadow: "0 16px 34px rgba(20, 13, 24, 0.3)",
      buttonStyle: "solid",
      buttonSize: "comfortable",
      fontFamily: "Poppins",
      profileCardBackgroundColor: "rgba(255, 246, 238, 0.09)",
    },
  },
  {
    key: "ember",
    label: "Ember",
    theme: {
      backgroundStyle: "gradient",
      backgroundColor: "#24130c",
      backgroundAccentColor: "#713c21",
      surfaceColor: "rgba(255, 246, 238, 0.09)",
      textColor: "#fffaf5",
      mutedTextColor: "rgba(255, 250, 245, 0.85)",
      buttonTextColor: "#24130c",
      buttonBackgroundColor: "#ffeadb",
      buttonOutlineColor: "rgba(255, 242, 229, 0.22)",
      buttonRadius: 20,
      buttonShadow: "0 16px 34px rgba(20, 13, 24, 0.3)",
      buttonStyle: "solid",
      buttonSize: "comfortable",
      fontFamily: "Poppins",
      profileCardBackgroundColor: "rgba(255, 246, 238, 0.09)",
    },
  },
  {
    key: "saffron",
    label: "Saffron",
    theme: {
      backgroundStyle: "gradient",
      backgroundColor: "#211d0b",
      backgroundAccentColor: "#675615",
      surfaceColor: "rgba(255, 246, 238, 0.09)",
      textColor: "#fffaf5",
      mutedTextColor: "rgba(255, 250, 245, 0.85)",
      buttonTextColor: "#211d0b",
      buttonBackgroundColor: "#fff4c7",
      buttonOutlineColor: "rgba(255, 242, 229, 0.22)",
      buttonRadius: 20,
      buttonShadow: "0 16px 34px rgba(20, 13, 24, 0.3)",
      buttonStyle: "solid",
      buttonSize: "comfortable",
      fontFamily: "Poppins",
      profileCardBackgroundColor: "rgba(255, 246, 238, 0.09)",
    },
  },
  {
    key: "forest-muse",
    label: "Forest Muse",
    theme: {
      backgroundStyle: "gradient",
      backgroundColor: "#081c15",
      backgroundAccentColor: "#2d6a4f",
      surfaceColor: "rgba(216, 243, 220, 0.08)",
      textColor: "#f1faee",
      mutedTextColor: "rgba(241, 250, 238, 0.92)",
      buttonTextColor: "#081c15",
      buttonBackgroundColor: "#d8f3dc",
      buttonOutlineColor: "rgba(216, 243, 220, 0.24)",
      buttonRadius: 18,
      buttonShadow: "0 18px 38px rgba(8, 28, 21, 0.32)",
      buttonStyle: "solid",
      buttonSize: "comfortable",
      fontFamily: "Montserrat",
      profileCardBackgroundColor: "rgba(216, 243, 220, 0.08)",
    },
  },
  {
    key: "tiffany",
    label: "Tiffany",
    theme: {
      backgroundStyle: "gradient",
      backgroundColor: "#062325",
      backgroundAccentColor: "#176167",
      surfaceColor: "rgba(255, 246, 238, 0.09)",
      textColor: "#fffaf5",
      mutedTextColor: "rgba(255, 250, 245, 0.85)",
      buttonTextColor: "#062325",
      buttonBackgroundColor: "#d9f8f5",
      buttonOutlineColor: "rgba(255, 242, 229, 0.22)",
      buttonRadius: 20,
      buttonShadow: "0 16px 34px rgba(20, 13, 24, 0.3)",
      buttonStyle: "solid",
      buttonSize: "comfortable",
      fontFamily: "Poppins",
      profileCardBackgroundColor: "rgba(255, 246, 238, 0.09)",
    },
  },
  {
    key: "blue-hour",
    label: "Blue Hour",
    theme: {
      backgroundStyle: "gradient",
      backgroundColor: "#061426",
      backgroundAccentColor: "#1d3d6f",
      surfaceColor: "rgba(232, 241, 255, 0.08)",
      textColor: "#f4f8ff",
      mutedTextColor: "rgba(244, 248, 255, 0.7)",
      buttonTextColor: "#0b1d38",
      buttonBackgroundColor: "#e5efff",
      buttonOutlineColor: "rgba(229, 239, 255, 0.2)",
      buttonRadius: 18,
      buttonShadow: "0 16px 34px rgba(3, 12, 28, 0.34)",
      buttonStyle: "solid",
      buttonSize: "comfortable",
      fontFamily: "Montserrat",
      profileCardBackgroundColor: "rgba(232, 241, 255, 0.08)",
    },
  },
  {
    key: "ultraviolet",
    label: "Ultraviolet",
    theme: {
      backgroundStyle: "gradient",
      backgroundColor: "#0b0718",
      backgroundAccentColor: "#402675",
      surfaceColor: "rgba(243, 232, 255, 0.09)",
      textColor: "#fbf8ff",
      mutedTextColor: "rgba(251, 248, 255, 0.72)",
      buttonTextColor: "#21113e",
      buttonBackgroundColor: "#f0e6ff",
      buttonOutlineColor: "rgba(240, 230, 255, 0.22)",
      buttonRadius: 24,
      buttonShadow: "0 18px 36px rgba(11, 7, 24, 0.36)",
      buttonStyle: "solid",
      buttonSize: "comfortable",
      fontFamily: "Montserrat",
      profileCardBackgroundColor: "rgba(243, 232, 255, 0.09)",
    },
  },
];

export const SOCIAL_PLATFORM_OPTIONS = [
  { value: "instagram", label: "Instagram", placeholder: "https://instagram.com/yourname" },
  { value: "tiktok", label: "TikTok", placeholder: "https://www.tiktok.com/@yourname" },
  { value: "youtube", label: "YouTube", placeholder: "https://youtube.com/@yourname" },
  { value: "telegram", label: "Telegram", placeholder: "https://t.me/yourname" },
  { value: "threads", label: "Threads", placeholder: "https://www.threads.net/@yourname" },
  { value: "x", label: "X / Twitter", placeholder: "https://x.com/yourname" },
  { value: "facebook", label: "Facebook", placeholder: "https://facebook.com/yourname" },
  { value: "vk", label: "VK", placeholder: "https://vk.com/yourname" },
  { value: "bluesky", label: "Bluesky", placeholder: "https://bsky.app/profile/yourname" },
  { value: "mastodon", label: "Mastodon", placeholder: "https://mastodon.social/@yourname" },
  { value: "linkedin", label: "LinkedIn", placeholder: "https://linkedin.com/in/yourname" },
  { value: "spotify", label: "Spotify", placeholder: "https://open.spotify.com/artist/..." },
  { value: "appleMusic", label: "Apple Music", placeholder: "https://music.apple.com/..." },
  { value: "youtubeMusic", label: "YouTube Music", placeholder: "https://music.youtube.com/channel/..." },
  { value: "zvuk", label: "Zvuk", placeholder: "https://zvuk.com/artist/..." },
  { value: "soundcloud", label: "SoundCloud", placeholder: "https://soundcloud.com/yourname" },
  { value: "bandcamp", label: "Bandcamp", placeholder: "https://yourname.bandcamp.com" },
  { value: "deezer", label: "Deezer", placeholder: "https://www.deezer.com/artist/..." },
  { value: "twitch", label: "Twitch", placeholder: "https://twitch.tv/yourname" },
  { value: "discord", label: "Discord", placeholder: "https://discord.gg/..." },
  { value: "reddit", label: "Reddit", placeholder: "https://reddit.com/user/yourname" },
  { value: "pinterest", label: "Pinterest", placeholder: "https://pinterest.com/yourname" },
  { value: "snapchat", label: "Snapchat", placeholder: "https://snapchat.com/add/yourname" },
  { value: "tumblr", label: "Tumblr", placeholder: "https://yourname.tumblr.com" },
  { value: "substack", label: "Substack", placeholder: "https://yourname.substack.com" },
  { value: "patreon", label: "Patreon", placeholder: "https://patreon.com/yourname" },
  { value: "boosty", label: "Boosty", placeholder: "https://boosty.to/yourname" },
  { value: "behance", label: "Behance", placeholder: "https://behance.net/yourname" },
  { value: "dribbble", label: "Dribbble", placeholder: "https://dribbble.com/yourname" },
  { value: "github", label: "GitHub", placeholder: "https://github.com/yourname" },
  { value: "googleBusiness", label: "Google Business", placeholder: "https://g.page/..." },
  { value: "max", label: "Max", placeholder: "https://max.ru/..." },
  { value: "website", label: "Website", placeholder: "https://yourwebsite.com" },
];

export const CONTACT_PLATFORM_OPTIONS = [
  { value: "email", label: "Email", placeholder: "hello@example.com" },
  { value: "phone", label: "Phone", placeholder: "+1 555 123 4567" },
  { value: "whatsapp", label: "WhatsApp", placeholder: "+1 555 123 4567" },
  { value: "telegram", label: "Telegram", placeholder: "@yourhandle" },
];
